export default "__VITE_ASSET__4a369f50__"